import React from 'react';
import { getAssetsPrefix } from '../../../../utils/buildVersion';

const styles: Record<string, React.CSSProperties> = {
    container: {
        height: 'fit-content',
        display: 'flex',
        justifyContent: 'center',
    },
    imageContainer: {
        textAlign: 'center',
        padding: '0 10px 5px',
    },
    heading: {
        textAlign: 'center',
        padding: '20px 0px 13px 0',
    },
};

const assetPrefix = getAssetsPrefix();

export const Seal = ({ className }: { className?: string }) => {
    const sealStyles: any = {
        imageSize: {
            maxWidth: '155px',
        },
        footerSealHeading: {
            fontSize: '12px',
            fontWeight: '100',
            textTransform: 'uppercase',
        },
    };

    return (
        <div className={className}>
            <div style={{ ...styles.heading, ...sealStyles.footerSealHeading }}>
                Unsere Auszeichnungen
            </div>
            <div style={styles.container}>
                <div style={styles.imageContainer}>
                    <img
                        src={`${assetPrefix}/static/images/kreuzfahrtportal_kundenservice.jpg`}
                        style={sealStyles.imageSize}
                        alt="Kreuzfahrt Portal Kundenservice"
                    />
                </div>
                <div style={styles.imageContainer}>
                    <img
                        src={`${assetPrefix}/static/images/kreuzfahrtportal_kundenzufriedenheit.jpg`}
                        style={sealStyles.imageSize}
                        alt="Kreuzfahrt Portal Kundenzufriedenheit"
                    />
                </div>
                <div style={styles.imageContainer}>
                    <img
                        src={`${assetPrefix}/static/images/kreuzfahrtportal_price.jpg`}
                        style={sealStyles.imageSize}
                        alt="Kreuzfahrt Portal Price"
                    />
                </div>
            </div>
        </div>
    );
};
